export type ColorScheme = "light" | "dark" | "system"

export const STORAGE_KEYS = {
  THEME_ID: "opencode-theme-id",
  COLOR_SCHEME: "opencode-color-scheme",
  THEME_CSS_LIGHT: "opencode-theme-css-light",
  THEME_CSS_DARK: "opencode-theme-css-dark",
  APPEARANCE_DEFAULTS: "datox-appearance-defaults",
} as const

export const APPEARANCE_DEFAULTS_VERSION = "datox-light-v1"

export function loadThemePreferences(
  defaultTheme = "datox",
  storage: () => Pick<Storage, "getItem" | "setItem" | "removeItem"> = () => localStorage,
) {
  const defaults = { themeId: defaultTheme, colorScheme: "light" as ColorScheme }
  try {
    const store = storage()
    // Apply the new defaults once, then preserve subsequent user choices.
    if (store.getItem(STORAGE_KEYS.APPEARANCE_DEFAULTS) !== APPEARANCE_DEFAULTS_VERSION) {
      store.setItem(STORAGE_KEYS.THEME_ID, defaultTheme)
      store.setItem(STORAGE_KEYS.COLOR_SCHEME, "light")
      store.removeItem(STORAGE_KEYS.THEME_CSS_LIGHT)
      store.removeItem(STORAGE_KEYS.THEME_CSS_DARK)
      store.setItem(STORAGE_KEYS.APPEARANCE_DEFAULTS, APPEARANCE_DEFAULTS_VERSION)
      return defaults
    }

    const savedTheme = store.getItem(STORAGE_KEYS.THEME_ID) || defaultTheme
    const themeId = savedTheme === "oc-1" ? "oc-2" : savedTheme
    if (themeId !== savedTheme) {
      store.setItem(STORAGE_KEYS.THEME_ID, themeId)
      store.removeItem(STORAGE_KEYS.THEME_CSS_LIGHT)
      store.removeItem(STORAGE_KEYS.THEME_CSS_DARK)
    }
    const savedScheme = store.getItem(STORAGE_KEYS.COLOR_SCHEME)
    const colorScheme: ColorScheme = savedScheme === "dark" || savedScheme === "system" ? savedScheme : "light"
    return { themeId, colorScheme }
  } catch {
    return defaults
  }
}
